import React, { Component } from 'react';

// Externals
import axios from 'axios';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core';
import { withRouter } from "react-router-dom";
// Material components
import { Grid } from '@material-ui/core';

// Shared layouts
import { Application as ApplicationLayout } from 'layouts';
import AddContact from "./components/AddContact";
import Avatar from "./components/Avatar";
// Material table
import MaterialTable from 'material-table'

// Material Kit
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
// import Button from "components/CustomButtons/Button.jsx";

// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
import withAuth from 'components/Auth/withAuth.jsx';

// import { cardTitleWhite, cardCategoryWhite } from "assets/jss/material-kit-pro-react.jsx";

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

class ContactsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      AddContactModal: false
    };
  }

  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  handleClickDelete(contact) {

    window.confirm("You want to delete " + contact);

  }

  render() {
    const { classes } = this.props;
    const { confirm } = this.props;

    return (
      <ApplicationLayout title="Contacts">
        <div className={classes.root}>
          <Grid
            container
            spacing={8}
          >
            <Grid
              item
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >

            </Grid>

            <Grid
              item
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >
              <Card plain>
              {/*
                <CardHeader plain color="info">
                  <h4 className={classes.cardTitleWhite}>Contact list</h4>
                  <p className={classes.cardCategoryWhite}>
                    List, search and filter contacts
                  </p>
                </CardHeader>
              */}
                <CardBody>

                  <MaterialTable
                  columns={[
                    { title: 'Avatar', field: 'attributes.avatar',
                      render: rowData => <Avatar uri={rowData.attributes.avatar} id={rowData.attributes.id}/>
                    },
                    { title: 'Id', field: 'id' },
                    { title: 'Name', field: 'attributes.first_name' },
                    { title: 'Surname', field: 'attributes.last_name' },
                    { title: 'Phone', field: 'attributes.phone_number' },
                    { title: 'Email', field: 'attributes.email' },
                    { title: 'Address', field: 'attributes.full_address' },
                    { title: 'Active', field: 'attributes.active', type: 'boolean' }

                  ]}
                  data={query =>
                      new Promise((resolve, reject) => {
                        let url = `${process.env.REACT_APP_API_URL}contacts?`
                        url += 'per_page=' + query.pageSize
                        url += '&page=' + (query.page + 1)
                        url += '&search=' + query.search
                        console.log(query);
                        const headers = {
                          Accept: "application/json",
                          "Content-Type": "application/json"
                        };

                        headers["Authorization"] = "Bearer " + confirm;

                        fetch(url, {
                          headers
                        })
                          .then(response => response.json())
                          .then(result => {
                            resolve({
                              data: result.data,
                              page: result.meta.page - 1,
                              totalCount: result.meta.total,
                            })
                          })
                      })
                    }
                  title="Contacts"
                  options={{
                    grouping: true,
                    search: true,
                    filtering: true,
                    exportButton: true,
                    actionsColumnIndex: 0
                  }}
                  actions={[
                              {
                                icon: 'forward',
                                tooltip: 'go to contact profile',
                                onClick: (event, rowData) => this.props.history.push('/contacts/' + rowData.id )
                              },
                              {
                                icon: 'add',
                                tooltip: 'Add contact',
                                isFreeAction: true,
                                onClick: (event) => this.handleClickOpen("AddContactModal")
                              }
                            ]}
                  editable={{

                            onRowUpdate: (newData, oldData) =>
                              new Promise((resolve, reject) => {
                                setTimeout(() => {

                                  resolve();
                                }, 1000)
                              }),
                            onRowDelete: oldData =>
                              new Promise((resolve, reject) => {

                                setTimeout(() => {
                                  const { confirm } = this.props;
                                  let url = `${process.env.REACT_APP_API_URL}contacts/` + oldData.id + '.json';
                                  axios
                                    .delete(url,{headers:{ Authorization: 'Bearer ' + confirm }})
                                    .then(response => {
                                      this.setState({ Updated: true });
                                    })
                                    .catch((error) => {
                                      console.log(error);
                                    });

                                  resolve()
                                }, 1000)
                              }),
                          }}

                />
                </CardBody>
              </Card>
            </Grid>

          </Grid>
        </div>
        <AddContact confirm={this.props.confirm} handleClose={this.handleClose.bind(this)} isOpen={this.state.AddContactModal}/>
      </ApplicationLayout>
    );
  }
}

ContactsPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withAuth,
  withStyles(styles),
  withRouter
)(ContactsPage);
